'use client';

import React from 'react';
import { TasticProps } from '../types';

const TestText = ({ data }: TasticProps<any>) => {
  return <h1>{data.headline}</h1>;
};

export default TestText;
